import { Injector } from '@angular/core';
import {
  scalePoint,
  subtractPoints,
} from '../../../../../shared/misc-utilities/point-utils';
import { ViewBoxService } from '../../../utils/view-box.service';
import { VectorRendererCursorCssPropertyService } from '../../../vector-renderer/vector-renderer-cursor-css-property.service';
import { AbstractDragHandler2D } from './abstract-drag-handler-2d';

export class PanningDragHandler extends AbstractDragHandler2D {
  private initialPoint = this.store.state().mouse.clientPoint;
  private viewBoxService: ViewBoxService;
  private vectorRendererCursorCssPropertyService: VectorRendererCursorCssPropertyService;

  constructor(initialEvent: MouseEvent, injector: Injector) {
    super(initialEvent, injector);

    this.viewBoxService = injector.get(ViewBoxService);
    this.vectorRendererCursorCssPropertyService = injector.get(
      VectorRendererCursorCssPropertyService,
    );

    this.vectorRendererCursorCssPropertyService.draggingStatus$.next('waiting');

    void this.completion.then(() =>
      this.vectorRendererCursorCssPropertyService.draggingStatus$.next(
        'completed',
      ),
    );
  }

  protected onDrag() {
    this.vectorRendererCursorCssPropertyService.draggingStatus$.next(
      'dragging',
    );
    const currentPoint = this.store.state().mouse.clientPoint;
    const offsetFromInitial = subtractPoints(this.initialPoint, currentPoint);

    this.viewBoxService.panWithOffset(
      scalePoint(offsetFromInitial, 1 / this.store.state().scale),
      'right_button_mouse_drag',
    );
    this.initialPoint = currentPoint;
  }
}
